<div class="checkbox mb-1" *ngIf="isCompareType">
  <input
    id="{{ labelName }}"
    type="checkbox"
    name="{{ accessoryName }}"
    [checked]="isCheckedDefault"
    (click)="onCheckboxToggle()"
    [disabled]="isCheckboxDisabled"
    attr.data-e2e="{{ selector }}-input-checkbox"
  />
  <label for="{{ labelName }}" class="label">{{ labelName }}</label>
</div>
<label *ngIf="!isCompareType" class="label">{{ labelName }}</label>
<div class="dropdown" [class.is-active]="isOpen" attr.data-e2e="{{ selector }}-button-dropdown">
  <div class="drodown-trigger">
    <button
      [className]="isNewDesignFilter ? 'button' : 'button is-chip is-size-7-mobile'"
      [class.is-applied]="selectedEntities.size"
      [class.is-active]="isOpen"
      [attr.aria-expanded]="isOpen"
      [disabled]="!isCheckedDefault"
      (click)="toggleOpen()"
      (keydown.space)="onKeyDownSpace($event)"
      attr.data-e2e="{{ selector }}-button-open"
      title="{{ dateHeaderText }}"
      type="button"
      #dateFilter
    >
      <span attr.data-e2e="{{ selector }}-button-text">{{ dateHeaderText }}</span>
      <span class="icon">
        <i class="fas fa-chevron-down"></i>
      </span>
    </button>
  </div>
  <div class="dropdown-menu" name="date-drop-down">
    <div class="dropdown-content">
      <div class="has-border-bottom is-flex-grow-2">
        <portal-date-picker
          #datePicker
          [fromDate]="fromDate"
          [toDate]="toDate"
          [fromTime]="fromTime"
          [toTime]="toTime"
          [showTimePicker]="showTimePicker"
          [isCompareTo]="isCompareType"
          [dateRangeSelection]="dateRangeSelection"
          [markDisabled]="markDisabled"
          [quickPicksList]="quickPicks"
          [showQuickPicks]="showQuickPicks"
          [oneHourTimeDifference]="true"
          (fromDateApplied)="onFromDateApplied($event)"
          (toDateApplied)="onToDateApplied($event)"
          (fromTimeApplied)="onFromTimeApplied($event)"
          (toTimeApplied)="onToTimeApplied($event)"
          (isInvalidDate)="updateIsInvalidDate($event)"
          (isInvalidTime)="updateIsInvalidTime($event)"
          (quickPickSelected)="onQuickPickApplied($event)"
        >
        </portal-date-picker>
      </div>
      <div class="is-flex pb-0 pl-3 pt-3">
        <div class="is-flex">
          <button
            class="button is-primary"
            attr.data-e2e="{{ selector }}-button-apply"
            (click)="onFilterApplied()"
            (keydown.space)="onKeyDownSpaceApply($event)"
            [disabled]="!areDatesValid()"
            type="button"
            i18n
            title="Apply"
            i18n-title
          >
            Apply
          </button>
          <button
            class="button is-primary is-outlined ml-3"
            attr.data-e2e="{{ selector }}-button-cancel"
            (click)="toggleOpen()"
            type="button"
            i18n
            title="Cancel"
            i18n-title
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
